import {
  doGETRequest,
  doPOSTRequest,
  doPUTRequest,
  doPATCHRequest,
  doDELETERequest
} from "./Api";

class ProductApi {
  
  public static async createOrUpdate(data: any) {
    const relativePath = "/products";
    if(data.id) {
      return this.update(data);
    }
    return this.create(data);
  }
  
  public static async create(data: any) {
    const relativePath = "/products";
    var response = await doPOSTRequest(relativePath, data);
    return response;
  }

  public static async update(data: any) {
    const relativePath = "/products";
    var response = await doPUTRequest(relativePath, data);
    return response;
  }
  
  public static async basketList() {
    return await doGETRequest("/products/basket-list");
  }

  public static async listAll(packagingGroup?:any) {
    const relativePath = "/products"+("?packagingGroup="+(packagingGroup || "ALL"));
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listPackagingGroups() {
    const relativePath = "/products/packagingGroups"
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listStocksOf(productId:any) {
    const relativePath = "/products/"+productId+"/stocks"
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAllItemCards() {
    const relativePath = "/products/item-cards";
    var response = await doGETRequest(relativePath);
    return response;
  }
  public static async listAllProductCards() {
      const relativePath = "/products/product-cards";
      var response = await doGETRequest(relativePath);
      return response;
  }

  public static async listAllBoxedProductCards() {
      const relativePath = "/products/product-boxed-cards"
      var response = await doGETRequest(relativePath);
      return response;
  }

  public static async deactivate(productId: number) {
    const relativePath = "/products/" + productId;
    var response = await doDELETERequest(relativePath,"");
    return response;
  }

  public static async reactivate(productId: number) {
    return await doPATCHRequest(`/products/${productId}/activate`, {});
  }

  public static async listPagedSearch(search: string = "", page: number = 0, size: number = 50) {
    const qs = new URLSearchParams({ search: search || "", page: String(page), size: String(size) });
    return await doGETRequest(`/products/paged-search?${qs.toString()}`);
  }

  public static async listPagedPassive(search: string = "", page: number = 0, size: number = 50) {
    const qs = new URLSearchParams({ search: search || "", page: String(page), size: String(size) });
    return await doGETRequest(`/products/paged-passive?${qs.toString()}`);
  }

}

export default ProductApi;
